


























import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class CustomPropertySummary extends Vue {
  @Prop({
    required: false,
    default: {
      countOfInspectionsOfManager: 0,
      countOnAfterApprovalReady: 0,
      countOnApprovalReady: 0,
    }
  })
  readonly data!: {};
  private selectedSummary = '';
}
